import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-SaveSearchFeedbackModal" */'shared-components/components/SaveSearchFeedbackModal'));
